import { createSvgIcon } from '../../createSvgIcon';

export const FlagIcon = createSvgIcon(
  <>
    <path
      d="M1 15.4004V11.15M1 11.15C5.6544 7.50998 9.1456 14.79 13.8 11.15V2.05078C9.1456 5.69078 5.6544 -1.58922 1 2.05078V11.15Z"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  { displayName: 'FlagIcon', viewBox: '0 0 15 17' }
);
